export type Fact = { label: string; value: React.ReactNode }

/** Label/value rows separated by hairlines, for project and company details. */
const Facts = ({ items }: { items: Fact[] }) => (
  <dl className="my-8 divide-y divide-zinc-200 border-y border-zinc-200 dark:divide-zinc-800 dark:border-zinc-800">
    {items.map((fact) => (
      <div
        key={fact.label}
        className="grid gap-1 py-3 sm:grid-cols-[13rem_1fr] sm:gap-6"
      >
        <dt className="text-sm text-zinc-500">{fact.label}</dt>
        <dd className="text-black dark:text-white">{fact.value}</dd>
      </div>
    ))}
  </dl>
)

export default Facts
